import React, { useEffect, useState, useRef } from "react";
import QuickServices from "./QuickServices";
import FindAgentSection from "./FindAgentSection";
import ClaimManagement from "./ClaimManagement";
import AboutUAIC from "./AboutUAIC";
import WhatWeOffer from "./WhatWeOffer";
import BecomeAnAgent from "./BecomeAnAgent";
import QuoteSection from "./QuoteSection";
import FirstPage from "./firstPage";
import left_black_arrow from "../../assets/img/left_black_arrow.svg";
import left_grey_arrow from "../../assets/img/left_grey_arrow.svg";
import right_black_arrow from "../../assets/img/right_black_arrow.svg";
import checkIcon from "../../assets/img/check.svg";
import video1 from "../../assets/vids/video_1.mp4";
import video2 from "../../assets/vids/video_2.mp4";
import video3 from "../../assets/vids/video_3.mp4";
import video4 from "../../assets/vids/video_4.mp4";
import video5 from "../../assets/vids/video_5.mp4";
import emptyCaptions from "../../components/empty-captions.vtt";

import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

import "./Home.css";

import { useDispatch, useSelector } from "react-redux";
import Axios from "axios";
import GA from "../functions/GA";
import selectCorrectUrls from "../../selectCorrectUrls";
import { isMobile, isIE } from "react-device-detect";
import VideoCarousel from "./VideoCarousel";

export default function Home() {
  const dispatch = useDispatch();
  const campaign = useSelector((state) => state.campaignReducer);
  const [zipCode, setZipCode] = useState("");
  const [agentzipCode, setAgentZipCode] = useState("");
  const [message, setMessage] = useState(false);
  const [submitRequest, setSubmitRequest] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [displayNoAgentsFound, setNoAgentsFound] = useState(false);
  const [isGetAQuoteOpen, setIsGetAQuoteOpen] = useState(false);
  const [isContinuePreviousQuote, setIsContinuePreviousQuote] = useState(false);
  const [activeTab, setActiveTab] = useState("agent");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const [showContinuePreviousQuote, setshowContinuePreviousQuote] =
    useState(false);
  const [licenseNumber, setLicenseNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [quoteSearchResult, setquoteSearchResult] = useState("");
  const [quoteErrorResult, setquoteErrorResult] = useState("");
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [pinNumber, setpinNumber] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(180);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (secondsLeft <= 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const handleResend = () => {
    // Call your resend API here
    setSecondsLeft(180);
    setCanResend(false);
  };

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  const inputRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        checkZipCodeValidation();
        const href = selectCorrectHrefForTheZip();
        if (href !== "javascript:void(0)") {
          window.open(href);
        }
      }
    };

    const currentInput = inputRef.current;
    if (currentInput) {
      currentInput.addEventListener("keydown", handleKeyDown);
    }

    return () => currentInput?.removeEventListener("keydown", handleKeyDown);
  }, []);

  const leftText = [
    {
      text: "Fast & Easy Online Quotation",
    },
    {
      text: "Lienholder Verification is now available",
    },
    {
      text: "Renew a Policy",
    },
    {
      text: "You can report claim 24/7 from any device!",
    },
    {
      text: "Additional Help",
    },
  ];

  const videoThumbnails = [
    {
      // src: "https://player.vimeo.com/video/702177843?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1",
      src: video1,
      thumbnail: require("../../assets/img/video_thumb1.svg"),
      activeThumbnail: require("../../assets/img/active_video_thumb1.svg"),
      label: "Start Online Quote",
    },
    {
      // src: "https://player.vimeo.com/video/702177843?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1",
      src: video2,
      thumbnail: require("../../assets/img/video_thumb2.svg"),
      activeThumbnail: require("../../assets/img/active_video_thumb2.svg"),
      label: "Lienholder Verification",
    },
    {
      // src: "https://player.vimeo.com/video/702177844?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1",
      src: video3,
      thumbnail: require("../../assets/img/video_thumb3.svg"),
      activeThumbnail: require("../../assets/img/active_video_thumb3.svg"),
      label: "Renew a\n Policy",
    },
    {
      // src: "https://player.vimeo.com/video/702177844?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1",
      src: video4,
      thumbnail: require("../../assets/img/video_thumb4.svg"),
      activeThumbnail: require("../../assets/img/active_video_thumb4.svg"),
      label: "Claims\n Portal",
    },
    {
      // src: "https://player.vimeo.com/video/702177844?h=f698312f3a&amp;portrait=0&amp;byline=0&amp;title=0&amp;autoplay=1&muted=1&background=1",
      src: video5,
      thumbnail: require("../../assets/img/video_thumb5.svg"),
      activeThumbnail: require("../../assets/img/active_video_thumb5.svg"),
      label: "Additional Help",
    },
  ];

  const [backgroundVideo, setBackgroundVideo] = useState(
    videoThumbnails[0].src
  );
  const [thumbStart, setThumbStart] = useState(0);
  const THUMBNAILS_PER_PAGE = 3;

  // useEffect(() => {
  //   const visibleThumbnails = videoThumbnails.slice(thumbStart, thumbStart + THUMBNAILS_PER_PAGE);
  //   if (visibleThumbnails.length > 1) {
  //     setBackgroundVideo(visibleThumbnails[1].src);
  //   }
  // }, [thumbStart, THUMBNAILS_PER_PAGE, videoThumbnails]);

  const selectCorrectHrefForTheZipAgents = (e) => {
    const firstTwo = agentzipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79" ||
      firstTwo === "32" ||
      firstTwo === "33" ||
      firstTwo === "34"
    ) {
      setNoAgentsFound(false);
    } else {
      setNoAgentsFound(true);
      setIsErrorMessage(true);
      setMessage("No Agents found in this Zip Code");
      return "javascript:void(0)";
    }
  };

  useEffect(() => {
    if (submitRequest) {
      window.location.hash = "/uaichome/FindAnAgent?zip=" + agentzipCode;
      if (agentzipCode.length === 5) {
        dispatch({
          type: "SET_AGENT_LOCATOR_ZIP",
          payload: agentzipCode,
        });
      }
    }
  }, [submitRequest]);

  const getTodaysDate = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();

    today = yyyy + "/" + mm + "/" + dd;

    return today;
  };

  const getCurrentTime = () => {
    var d = new Date();
    d.getHours();
    d.getMinutes();
    d.getSeconds();

    let time = new Date().toTimeString().slice(0, 8);

    return time;
  };

  const selectCorrectHrefForTheZip = (e) => {
    const firstTwo = zipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79"
    ) {
      return `${
        selectCorrectUrls().quotePortal
      }/uaicins/txsale/quick/start/UAIS?campaign=${campaign}`;
      // }/selfquotetx/#/selfquote/`;
    } else if (firstTwo === "32" || firstTwo === "33" || firstTwo === "34") {
      return `${
        selectCorrectUrls().quotePortal
      }/uaicins/sale/quick/index/UAI?campaign=${campaign}`;
      //}/selfquote/#/selfquote/`;
    } else {
      return "javascript:void(0)";
    }
  };

  const checkZipCodeValidationAgents = () => {
    const firstTwo = agentzipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79" ||
      firstTwo === "32" ||
      firstTwo === "33" ||
      firstTwo === "34"
    ) {
      setNoAgentsFound(false);
    } else {
      setNoAgentsFound(true);
      setIsErrorMessage(true);
      setMessage("No Agents found in this Zip Code");
    }
  };

  const checkZipCodeValidation = () => {
    const firstTwo = zipCode.substring(0, 2);

    if (
      firstTwo === "73" ||
      firstTwo === "75" ||
      firstTwo === "76" ||
      firstTwo === "77" ||
      firstTwo === "78" ||
      firstTwo === "88" ||
      firstTwo === "79" ||
      firstTwo === "32" ||
      firstTwo === "33" ||
      firstTwo === "34"
    ) {
      Axios.post(
        `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/sqzl/index?zipcode=${zipCode}&status=Y&time=${getCurrentTime()}&date=${getTodaysDate()}`
      )
        .then((response) => {})
        .catch((e) => {});
    } else {
      Axios.post(
        `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/sqzl/index?zipcode=${zipCode}&status=N&time=${getCurrentTime()}&date=${getTodaysDate()}`
      )
        .then((response) => {})
        .catch((e) => {});
    }
  };

  function numbersOnly(e) {
    var key = e.which || e.keyCode;
    var controlKeys = [8, 9, 13];
    var isControlKey =
      e.ctrlKey || controlKeys.join(",").match(new RegExp(key));
    if (isControlKey) {
      return;
    }
    if (!(48 <= key && key <= 57)) {
      e.preventDefault();
      return;
    }
  }

  function getUrlParams(search) {
    const hashes = search.slice(search.indexOf("?") + 1).split("&");
    const params = {};
    hashes.map((hash) => {
      const [key, val] = hash.split("=");
      params[key] = decodeURIComponent(val);
    });
    return params;
  }

  useEffect(() => {
    if (getUrlParams(window.location.hash).startquote === "undefined") {
      setIsGetAQuoteOpen(true);
    } else if (
      getUrlParams(window.location.hash).continuepreviousquote === "undefined"
    ) {
      setIsContinuePreviousQuote(true);
    }
  }, []);

  const continuePreviousQuoteComponent = () => {
    return (
      <div>
        <div
          onClick={() => {
            setIsContinuePreviousQuote(false);
            setIsGetAQuoteOpen(false);
          }}
          className={
            isContinuePreviousQuote || isGetAQuoteOpen
              ? "continue-previous-quote-dark-background-on"
              : "continue-previous-quote-dark-background-off"
          }
        ></div>
        <div
          className={
            isContinuePreviousQuote
              ? "continue-previous-quote-component-shown"
              : "continue-previous-quote-component-hidden"
          }
        >
          <div
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "white",
              paddingTop: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "1rem",
              }}
            >
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                  paddingBottom: "0rem",
                  marginBottom: "0rem",
                }}
              >
                Continue your previous quote{" "}
              </h3>
              <h2
                className="close-login-menu-icon"
                onClick={() => {
                  setIsContinuePreviousQuote(false);
                }}
                style={{
                  right: "0px",
                  top: "8px",
                  paddingBottom: "0rem",
                  marginBottom: "0rem",
                }}
                aria-label="Close"
              >
                <i
                  className="fa fa-times-circle"
                  style={{
                    fontSize: "25px",
                    color: "#01224f",
                    cursor: "pointer",
                  }}
                ></i>{" "}
                &nbsp;
              </h2>
            </div>
            <hr></hr>
          </div>

          <div>
            <FirstPage isOpened={isContinuePreviousQuote} />
          </div>
        </div>
      </div>
    );
  };

  const getAQuoteComponent = () => {
    return (
      <div
        className={
          isGetAQuoteOpen
            ? "get-a-quote-component-shown"
            : "get-a-quote-component-hidden"
        }
      >
        <h2
          style={{ top: 15 }}
          className="close-login-menu-icon"
          onClick={() => {
            setIsGetAQuoteOpen(false);
          }}
        >
          <i
            className="fa fa-times-circle"
            style={{ fontSize: "1.5em", color: "#01224f" }}
            aria-hidden="true"
          ></i>
        </h2>
        <form target="_blank" rel="noreferrer" autoComplete="false">
          <input
            id="zip-input-box-2"
            value={zipCode}
            maxLength="5"
            className="zip-input"
            placeholder="Enter zip code"
            onChange={(e) => {
              const sanitized = e.target.value.replace(/\D/g, "").slice(0, 5);
              setZipCode(sanitized);
            }}
            onPaste={(e) => {
              e.preventDefault();
              const pasted = e.clipboardData.getData("text");
              const digitsOnly = pasted.replace(/\D/g, "").slice(0, 5);
              if (digitsOnly) {
                setZipCode((prev) => (prev + digitsOnly).slice(0, 5));
              }
            }}
            onKeyDown={(e) => {
              const isDigit = /^[0-9]$/.test(e.key);
              const allowedControlKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
              ];
              const isControlCombo = e.ctrlKey || e.metaKey;

              if (
                !isDigit &&
                !allowedControlKeys.includes(e.key) &&
                !isControlCombo
              ) {
                e.preventDefault();
              }
            }}
          />

          <div
            onClick={() => {
              GA(
                "Start_Quote",
                "User clicked on Start Quote button, inside get a quote pop up"
              );

              if (zipCode === "") {
                dispatch({
                  type: "SET_ERROR_MESSAGE",
                  payload: true,
                });
                dispatch({
                  type: "SET_MESSAGE",
                  payload: "Please enter a zip code",
                });
              } else if (
                selectCorrectHrefForTheZip() === "javascript:void(0)"
              ) {
                dispatch({
                  type: "SET_ERROR_MESSAGE",
                  payload: true,
                });
                dispatch({
                  type: "SET_MESSAGE",
                  payload:
                    "Buy online currently not available in this zip code",
                });
                GA(
                  "Start_Quote_FAILED",
                  `ZIP: ${zipCode} - User clicked on Start Quote button`
                );
              }
            }}
          >
            <button
              onClick={(e) => {
                if (selectCorrectHrefForTheZip() === "javascript:void(0)") {
                  e.preventDefault();
                } else {
                  window.open(selectCorrectHrefForTheZip());
                }

                checkZipCodeValidation();
              }}
              className="start-quote-button home-page-card-button"
            >
              Start Quote
            </button>
          </div>
          <br></br>
          <p
            onClick={() => {
              setIsGetAQuoteOpen(false);
              setIsContinuePreviousQuote(true);
              setshowContinuePreviousQuote(true);
              GA(
                "Previous_Quote",
                "User clicked on the continue previous quote inside the get a quote pop up"
              );
            }}
            style={{
              cursor: "pointer",
              marginBottom: "10px",
              textDecoration: "underline",
            }}
            tabIndex={0}
            role="button"
          >
            Continue Previous Quote
          </p>
        </form>
      </div>
    );
  };

  const handlePrevious = () => {
    const newIndex =
      (currentIndex - 1 + videoThumbnails.length) % videoThumbnails.length;
    setCurrentIndex(newIndex);
    setBackgroundVideo(videoThumbnails[newIndex].src);
  };

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % videoThumbnails.length;
    setCurrentIndex(newIndex);
    setBackgroundVideo(videoThumbnails[newIndex].src);
  };

  const handleQuoteSubmit = async (e) => {
    e.preventDefault();

    if (!licenseNumber && !phoneNumber) {
      alert("Please enter either a License Number or Phone Number");
      return;
    }

    if (phoneNumber) {
      Axios.post(
        `https://mypolicy.uaig.net/uaicins/agent/zip/phonesearch?phone=${encodeURIComponent(
          phoneNumber
        )}`
      )
        .then((response) => {
          setquoteSearchResult(response.data);

          const data = response.data;

          if (data && data.OTP && data.CLID) {
            setshowContinuePreviousQuote(false);
            setLicenseNumber("");
            setPhoneNumber("");
            setShowVerifyPopup(true);
          } else {
            setquoteErrorResult(response.data.errorMsg);
          }
        })
        .catch((e) => {});
    } else if (licenseNumber) {
      Axios.post(
        // `${
        //     selectCorrectUrls().quotePortal
        //   }/uaicins/agent/zip/licsearch?licnum=${encodeURIComponent(licenseNumber)}`
        `https://mypolicy.uaig.net/uaicins/agent/zip/licsearch?licnum=${encodeURIComponent(
          licenseNumber
        )}`
      )
        .then((response) => {
          setquoteSearchResult(response.data);
          const data = response.data;
          if (data && data.OTP && data.CLID) {
            showContinuePreviousQuote(false);
            setShowVerifyPopup(true);

            data.OTP ? setShowVerifyPopup(true) : setShowVerifyPopup(false);
          } else {
            setquoteErrorResult(response.data.errorMsg);
          }
        })
        .catch((e) => {
          setquoteErrorResult(e);
        });
    }
  };

  const handleVerifyPIN = async (e) => {
    e.preventDefault();
    if (!pinNumber) {
      alert("Please enter either a pin Number");
      return;
    }

    try {
      let response;
      if (pinNumber) {
        response = await fetch(
          `${
            selectCorrectUrls().insuredPortalTest
          }/uaicins/agent/zip/validateopt?clid=${
            quoteSearchResult.CLID
          }&otp=${pinNumber}`
        );

        const result = await response.json();
        window.open(result.returnUrl, "_blank").focus();
        setpinNumber("");
        setShowVerifyPopup(false);
      }
      // You can handle next step here using `step` or navigate with the data
    } catch (error) {
      console.error("API error:", error);
      alert("Failed to fetch data. Please try again.");
    }
  };

  return (
    <>
      {/* {continuePreviousQuoteComponent()} */}

      <div
        className={
          responsiveStatus === "isDesktop"
            ? "fullscreen-container"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "fullscreen-container-t"
            : "fullscreen-container-m"
        }
      >
        <video
          src={backgroundVideo}
          autoPlay
          loop
          muted
          playsInline
          className={
            responsiveStatus === "isDesktop"
              ? "background-iframe"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "background-iframe-tab"
              : "background-iframe-m"
          }
        >
          <track
            kind="captions"
            src={emptyCaptions}
            srcLang="en"
            label="English"
          />
        </video>

        <div
          className={`${
            responsiveStatus === "isDesktop"
              ? "overlay"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "overlay-t"
              : "overlay-m"
          }`}
        >
          {/* <div style={{ width: "100%", maxWidth: "1350px", margin: "0 auto" }}> */}
          <div
            className={`${
              responsiveStatus === "isDesktop"
                ? "left-content"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "left-content-t"
                : "left-content-m"
            }`}
          >
            {responsiveStatus !== "isMobile" &&
              responsiveStatus !== "isSmallMobile" && (
                <p
                  style={{
                    color: "#000",
                    fontSize:
                      responsiveStatus === "isDesktop"
                        ? "20px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "20px"
                        : "19px",

                    fontWeight: 500,
                  }}
                >
                  <span className="blue-underline hide-mobile">
                    Drive with Co
                  </span>
                  nfidence, Insure with Ease!
                </p>
              )}

            <h2
              className={`${
                responsiveStatus === "isDesktop"
                  ? "headline"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "headline-t"
                  : "headline-m"
              }`}
              style={{ marginTop: "0.5em", fontSize: "48px" }}
            >
              {leftText[currentIndex].text ===
              "Fast & Easy Online Quotation" ? (
                <>
                  Fast & Easy <br /> Online Quotation
                </>
              ) : leftText[currentIndex].text ===
                "You can report claim 24/7 from any device!" ? (
                <>
                  You can report <br /> claim 24/7 from <br />
                  any device!
                </>
              ) : leftText[currentIndex].text ===
                "Lienholder Verification is now available" ? (
                <>
                  Lienholder <br /> Verification is now <br /> available
                </>
              ) : (
                leftText[currentIndex].text
              )}
              {/* Fast & Easy Online Quotation */}
            </h2>
            {currentIndex == 0 && (
              <>
                <div className="zip-container">
                  <input
                    id="zip-input-box-2"
                    value={zipCode}
                    maxLength="5"
                    className="zip-input"
                    placeholder="Enter zip code"
                    onChange={(e) => {
                      const sanitized = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 5);
                      setZipCode(sanitized);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pasted = e.clipboardData.getData("text");
                      const digitsOnly = pasted.replace(/\D/g, "").slice(0, 5);
                      if (digitsOnly) {
                        setZipCode((prev) => (prev + digitsOnly).slice(0, 5));
                      }
                    }}
                    onKeyDown={(e) => {
                      const isDigit = /^[0-9]$/.test(e.key);
                      const allowedControlKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];
                      const isControlCombo = e.ctrlKey || e.metaKey;

                      if (
                        !isDigit &&
                        !allowedControlKeys.includes(e.key) &&
                        !isControlCombo
                      ) {
                        e.preventDefault();
                      }
                      if (e.key === "Enter") {
                        const currentZip = e.target.value;

                        if (
                          selectCorrectHrefForTheZip(currentZip) ===
                            "javascript:void(0)" ||
                          currentZip.length !== 5
                        ) {
                          GA(
                            "Start_Quote_FAILED",
                            `ZIP: ${currentZip} - zip code entered and rejected`
                          );
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload: "Please enter a 5 digit zip code",
                          });
                          e.preventDefault();
                        } else {
                          GA(
                            "Start_Quote_SUCCESSFUL",
                            `ZIP: ${currentZip} - clicked on Start Quote button`
                          );
                          window.open(selectCorrectHrefForTheZip(currentZip));
                        }

                        if (currentZip === "") {
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload: "Please enter a 5 digit zip code",
                          });
                        } else if (
                          selectCorrectHrefForTheZip(currentZip) ===
                          "javascript:void(0)"
                        ) {
                          checkZipCodeValidation();
                          dispatch({
                            type: "SET_ERROR_MESSAGE",
                            payload: true,
                          });
                          dispatch({
                            type: "SET_MESSAGE",
                            payload:
                              "Buy online currently not available in this zip code",
                          });
                          GA(
                            "Start_Quote_FAILED",
                            `ZIP: ${currentZip} - zip code entered and rejected`
                          );
                        }
                      }
                    }}
                  />
                  <span
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "zip-arrow-d"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "zip-arrow"
                        : "zip-arrowM"
                    }`}
                    style={{ top: "50%" }}
                    onClick={(e) => {
                      checkZipCodeValidation();
                      if (
                        selectCorrectHrefForTheZip() === "javascript:void(0)"
                      ) {
                        e.preventDefault();
                      } else {
                        window.open(selectCorrectHrefForTheZip());
                      }
                    }}
                  >
                    <img
                      className="arrows"
                      src={require("../../assets/img/btn_arrow.png")}
                      alt="Arrow"
                      width={37}
                      height={37}
                    />
                  </span>
                </div>

                <ul
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "responsive-list"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "responsive-list-t"
                      : "responsive-list-m"
                  }`}
                >
                  <li>
                    <a
                      onClick={() => {
                        setIsContinuePreviousQuote(true);
                        setshowContinuePreviousQuote(true);
                        GA(
                          "Previous_Quote",
                          "User clicked on Continue previous quote"
                        );
                      }}
                      style={{ textDecoration: "none", color: "#007bff" }}
                      role="button"
                      tabIndex={0}
                    >
                      Continue Previous Quote
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        GA("Make_a_Payment", "User clicked on Make a payment");
                      }}
                      target="_blank"
                      rel="noreferrer"
                      href={
                        !isMobile
                          ? `${selectCorrectUrls().insuredPortal}/insurednew/`
                          : `${
                              selectCorrectUrls().insuredPortal
                            }/mobile/?rfm=yes`
                      }
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Make a Payment
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        GA(
                          "Make_a_Payment",
                          "User clicked on  Renew your policy"
                        );
                      }}
                      target="_blank"
                      rel="noreferrer"
                      href={
                        !isMobile
                          ? `${selectCorrectUrls().insuredPortal}/insurednew/`
                          : `${
                              selectCorrectUrls().insuredPortal
                            }/mobile/?rfm=yes`
                      }
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Renew Your Policy
                    </a>
                  </li>
                </ul>
              </>
            )}

            {currentIndex == 1 && (
              <>
                <p style={{ marginTop: "1.5em" }}>
                  Effortless Lienholder Verification – Trust, Verify, <br />
                  Secure
                </p>

                <Nav.Link
                  as={Link}
                  to="/uaichome/leinholder"
                  className="btn btn-primary-login"
                  style={{
                    width: "auto",
                    textAlign: "center",
                    maxWidth: "165px",
                  }}
                >
                  Verify Lien
                </Nav.Link>
              </>
            )}
            {currentIndex == 2 && (
              <>
                <p style={{ marginTop: "1.5em" }}>
                  Renew Your Ride with Ease – Quick, Simple, <br />
                  Secure Auto Insurance Renewals!
                </p>
                <a
                  href="https://mypolicy.uaig.net/insurednew/"
                  className="btn btn-primary-login nav-link"
                  style={{ maxWidth: "165px", width: "auto" }}
                >
                  Renew Now
                </a>
              </>
            )}
            {currentIndex == 3 && (
              <>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    color: "black",
                    fontWeight: "600",
                    marginTop: "1.5em",
                  }}
                >
                  {[
                    "Report a claim",
                    "Check claim status",
                    "Send documents or photos",
                    "Send message to your adjuster",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="">{item}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims"
                  className="btn btn-primary-login nav-link"
                  style={{ maxWidth: "165px" }}
                >
                  Click to Start
                </a>
              </>
            )}
            {currentIndex == 4 && (
              <>
                <p>We now have short videos that show how to:</p>

                <ul id="" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {[
                    "Report a claim",
                    "Check claim status",
                    "Send messages and documents to adjusters",
                    "Schedule vehicle damage estimates",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "12px",
                        display: "flex",
                        alignItems: "center",
                        color: "black",
                        fontWeight: "600",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="">{item}</span>
                    </li>
                  ))}
                </ul>

                {/* <a
                  href=""
                  className="btn btn-primary-login nav-link"
                  style={{ maxWidth: "165px" }}
                > */}
                {/* <Nav.Link
                  as={Link}
                  to="/uaichome/claims/faq#videos"
                  className="btn btn-primary-login"
                  style={{
                    width: "auto",
                    textAlign: "center",
                    maxWidth: "165px",
                  }}
                >
                  Watch Videos
                </Nav.Link> */}
                <Nav.Link
                  as={Link}
                  to="/uaichome/claims/faq#videos"
                  className="btn btn-primary-login"
                  style={{
                    width: "auto",
                    textAlign: "center",
                    maxWidth: "165px",
                  }}
                >
                  Watch Videos
                </Nav.Link>
                {/* </a> */}
              </>
            )}
          </div>

          <div
            className="scroll-container"
            style={{
              position: "absolute",
              bottom:
                responsiveStatus === "isDesktop"
                  ? 20
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "7px"
                  : "",
              right:
                responsiveStatus === "isDesktop"
                  ? 20
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? 20
                  : "14px",
              maxWidth: "100%",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              padding: "20px",
              borderRadius: "8px",

              // background: "rgba(0, 0, 0, 0.4)",
            }}
          >
            {/* Scrollable Thumbnails */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                WebkitOverflowScrolling: "touch",
                touchAction: "pan-x",
              }}
            >
              {videoThumbnails.map((video, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setBackgroundVideo(video.src);
                    setCurrentIndex(index);
                  }}
                  className={`thumbnail ${
                    backgroundVideo === video.src ? "active" : ""
                  }`}
                  style={{
                    flex: "0 0 auto",
                    minWidth: "120px",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={
                      backgroundVideo === video.src
                        ? video.activeThumbnail
                        : video.thumbnail
                    }
                    alt={`Video ${index + 1}`}
                    style={{
                      width: "100%",
                      borderRadius: "4px",
                    }}
                  />
                  <div className="thumbnail-caption">
                    <div className="thumbnail-index">{`0${index + 1}`}</div>
                    <div>{video.label}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Fixed Navigation Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop:
                  responsiveStatus === "isDesktop"
                    ? "8px"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "8px"
                    : "0px",
                marginLeft:
                  responsiveStatus === "isDesktop"
                    ? ""
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? ""
                    : "2%",
                gap: "10px",
              }}
            >
              <button
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "circle-button"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "circle-button"
                    : "circle-button-ml"
                }`}
                onClick={handlePrevious}
              >
                {/* &lt; */}

                {currentIndex === 0 && (
                  <img
                    style={{
                      height: responsiveStatus ? "30px" : "26px",
                      width: responsiveStatus ? "30px" : "26px",
                    }}
                    src={left_grey_arrow}
                    className="arrows"
                    alt="left_grey_arrow"
                  />
                )}
                {currentIndex !== 0 && (
                  <img
                    style={{
                      height: responsiveStatus ? "30px" : "26px",
                      width: responsiveStatus ? "30px" : "26px",
                    }}
                    src={left_black_arrow}
                    alt="left-arrow"
                    className="arrows"
                  />
                )}
              </button>
              <button
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "circle-button"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "circle-button"
                    : "circle-button-ml"
                }`}
                onClick={handleNext}
                style={{ marginLeft: "8px" }}
              >
                {/* &gt; */}
                <img
                  style={{
                    height:
                      responsiveStatus === "isDesktop"
                        ? "34px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "34px"
                        : "30px",

                    width:
                      responsiveStatus === "isDesktop"
                        ? "34px"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "34px"
                        : "30px",
                  }}
                  src={right_black_arrow}
                  alt="right-arrow"
                  className="arrows"
                />
              </button>
              <div className="line">&nbsp;</div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>

      {showContinuePreviousQuote && (
        <div
          className="modal show fade d-block modal-blur"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: "5em",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              width: responsiveStatus ? "80%" : "auto",
              // height : responsiveStatus ? '80%':'auto',
              maxWidth: "800px",
              margin: "1.75rem auto",
            }}
          >
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                style={{
                  width: responsiveStatus ? "auto" : "auto",
                  maxWidth: "800px",
                  margin: "1.75rem auto",
                }}
              >
                <div
                  className="modal-content p-0"
                  style={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    width: "auto",
                    // maxHeight: responsiveStatus ? '90vh' : '85%',
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    alignItems: "center",
                    // marginBottom: responsiveStatus ? '50vh' : 'auto'
                  }}
                >
                  {/* Modal Header */}
                  <div
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3 modalHeaderBar"
                    style={{ gap: "20px" }}
                  >
                    <h2
                      style={{
                        fontSize: responsiveStatus ? "18px" : "20px",
                      }}
                      className="m-0 modalHeading"
                    >
                      Continue your previous quote
                    </h2>
                    <button
                      className="btn-close closeButton"
                      onClick={() => {
                        setshowContinuePreviousQuote(false);
                        setLicenseNumber("");
                        setPhoneNumber("");
                      }}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{
                      // height: responsiveStatus?'100%':"265px",
                      overflow: responsiveStatus ? "auto" : "visible",
                    }}
                  >
                    {/* Right Content */}
                    <form onSubmit={(e) => handleQuoteSubmit(e, 1)}>
                      <div
                        className="content"
                        style={{
                          padding: "16px",
                        }}
                      >
                        <div className="policy-section">
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              License Number:
                            </label>
                            <input
                              name="name"
                              style={{ fontSize: "14px", color: "#A09999" }}
                              type="text"
                              className="form-control"
                              placeholder="License Number*"
                              value={licenseNumber}
                              onChange={(e) => setLicenseNumber(e.target.value)}
                            />
                          </div>
                          <p className="text-center my-2">Or</p>
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              Phone Number:
                            </label>
                            <input
                              name="phone"
                              style={{ fontSize: "14px", color: "#A09999" }}
                              type="number"
                              className="form-control"
                              placeholder="Phone Number"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                            />
                          </div>
                          <p style={{ color: "red" }}>{quoteErrorResult}</p>
                          <button
                            type="submit"
                            className="btn btn-primary-continue mt-2 w-100"
                            disabled={
                              licenseNumber === "" && phoneNumber.length !== 10
                            }
                            style={{
                              padding: "8px 16px",
                              fontWeight: 500,
                              fontSize: responsiveStatus ? "16px" : "18px",
                            }}
                          >
                            Continue
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      )}
      {showVerifyPopup && (
        <div
          className="modal show fade d-block modal-blur"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: "5em",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{
              width: responsiveStatus ? "80%" : "auto",
              // height : responsiveStatus ? '80%':'auto',
              maxWidth: "800px",
              margin: "1.75rem auto",
            }}
          >
            <div className="modal show d-block" tabIndex="-1" role="dialog">
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
                style={{
                  width: responsiveStatus ? "auto" : "auto",
                  maxWidth: "800px",
                  margin: "1.75rem auto",
                }}
              >
                <div
                  className="modal-content p-0"
                  style={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    width: "auto",
                    // maxHeight: responsiveStatus ? '90vh' : '85%',
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    alignItems: "center",
                    // marginBottom: responsiveStatus ? '50vh' : 'auto'
                  }}
                >
                  {/* Modal Header */}
                  <div
                    className="d-flex align-items-center justify-content-between px-3 px-md-4 py-3 modalHeaderBar"
                    style={{ gap: "20px" }}
                  >
                    <h2
                      style={{
                        fontSize: responsiveStatus ? "18px" : "20px",
                      }}
                      className="m-0 modalHeading"
                    >
                      Enter the Pin:
                    </h2>
                    <button
                      className="btn-close closeButton"
                      onClick={() => {
                        setShowVerifyPopup(false);
                      }}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{
                      // height: responsiveStatus?'100%':"265px",
                      overflow: responsiveStatus ? "auto" : "visible",
                    }}
                  >
                    {/* Right Content */}
                    <form onSubmit={(e) => handleVerifyPIN(e, 1)}>
                      <div
                        className="content"
                        style={{
                          padding: "16px",
                        }}
                      >
                        <div className="policy-section">
                          <div className="mb-3" style={{ textAlign: "left" }}>
                            {/* <label
                              className="form-label"
                              style={{ fontWeight: 600, fontSize: "14px" }}
                            >
                              License Number:
                            </label> */}
                            <input
                              name="name"
                              style={{ fontSize: "14px", color: "#A09999" }}
                              type="text"
                              className="form-control"
                              placeholder="Enter the Pin*"
                              value={pinNumber}
                              onChange={(e) => setpinNumber(e.target.value)}
                              required
                            />
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary-continue mt-2 w-100"
                            style={{
                              padding: "8px 16px",
                              fontWeight: 500,
                              fontSize: responsiveStatus ? "16px" : "18px",
                            }}
                          >
                            Verify
                          </button>
                          <p className="text-center my-2">
                            Didn’t receive it? Try again after {secondsLeft}{" "}
                            second{secondsLeft !== 1 && "s"}
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      )}

      <FindAgentSection responsiveStatus={responsiveStatus} />
      <ClaimManagement responsiveStatus={responsiveStatus} />
      <AboutUAIC responsiveStatus={responsiveStatus} />
      <QuickServices responsiveStatus={responsiveStatus} />
      <WhatWeOffer responsiveStatus={responsiveStatus} />
      <BecomeAnAgent responsiveStatus={responsiveStatus} />
      <VideoCarousel responsiveStatus={responsiveStatus} showBlueLine={true} />
      <QuoteSection responsiveStatus={responsiveStatus} />
    </>
  );
}
